import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import NavigationComponent from "../components/NavigationComponent";
import moment from "moment";
import { getAccountabilitiesTable } from "../../../../utils/daily-accountability";
import DoneMark from "../../../../parts/DoneMarkIcon";
import MonthController from "../../../../parts/MonthController";
import { AthleteLinks } from "../../../../parts/athlete-links";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import { ReportsBackHandler } from "../components/ReportsBackHandler";

const WEEK_DAY_KEYS = ["su", "mo", "tu", "we", "th", "fr", "sa"];

const AccountabilityTracker = (
  { query, pathname, dailyStats, athlete, coach, locals },
) => {
  const { t } = useTranslation("athlete-portal");
  const weekDays = WEEK_DAY_KEYS.map((key) =>
    t(`accountabilityTracker.weekDays.${key}`)
  );
  const templates = coach?.accountabilityTemplates?.templates ?? [];
  const defaultAssignments =
    coach?.accountabilityTemplates?.defaultAssignments ?? null;
  const athleteSignupDate = moment(athlete.registered).format("YYYYMMDD");
  const assignments = useMemo(
    () => athlete?.accountability?.assignments ?? [],
    [athlete]
  );

  const { date } = query;
  const [dateState, setDateState] = useState(
    date ? moment(date, "YYYYMMDD") : moment()
  );

  const [tableData, setTableData] = useState({});
  const [screenSize, setScreenSize] = useState({ width: null, height: null });
  useEffect(() => {
    let userAccountability;
    if (athlete.customAccountability && locals.dailyAccountabilityTemplate) {
      userAccountability = {
        ...athlete.customAccountability,
        accountabilities: locals.dailyAccountabilityTemplate.list,
      };
    }
    const data = getAccountabilitiesTable(
      dailyStats,
      dateState,
      assignments,
      templates,
      defaultAssignments,
      false,
      athleteSignupDate,
      userAccountability
    );

    setTableData(data);
  }, [dateState, screenSize, athlete]);
  const updateDimensions = () => {
    setScreenSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    setScreenSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", updateDimensions);
    return () => {
      return window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  return (
    <main className="acc-tracker">
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        textKey="nav.calendarDayView"
        pathName={pathname}
        classNames="mobile-hidden"
      />
      <section>
        <header>
          <h2 className="accountabilityTracker-title mobile-hidden">
            {t("metrics.accountabilityTracker")}
          </h2>
          <ReportsBackHandler
            title={t("metrics.accountabilityTracker")}
            locals={locals}
          />
          {screenSize.width !== null && (
            //      screenSize.width > 960 &&
            <div>
              <p className="s1">{t("accountabilityTracker.adherence")} &nbsp;</p>
              <div>
                <b>
                  <p className="s1">{tableData.averageAdherence.toFixed(2)}%</p>
                </b>
              </div>
            </div>
          )}
        </header>
        <hgroup>
          <MonthController
            date={dateState}
            setDate={setDateState}
            mobile={screenSize.width < 960 ? true : false}
          />
        </hgroup>
        <div className="Accountability-Table">
          {Object.keys(tableData).length > 0 && tableData.rows.length > 0 && (
            <div>
              <div className="Accountability-table-header">
                <div className="days-row-container">
                  {tableData.days.map((item) => {
                    return (
                      <div
                        key={item.dayNumber}
                        className="day-number-container"
                      >
                        <div className="accountability-day-abv">
                          {weekDays[item.key]}
                        </div>
                        <div className="accountability-day-num percentage-column">
                          {item.dayNumber}
                        </div>
                      </div>
                    );
                  })}
                  <div className="column-average-percentage">%</div>
                </div>
              </div>
              <div className="accountabilities-rows">
                {tableData.rows.map((row, i) => {
                  return (
                    <div key={row._id} className="accountability-row-container">
                      <div className="accountability-row-title">
                        {row.title}
                      </div>
                      <div className="accountability-row-marks-container">
                        {row.days.map((day, index) => {
                          if (day.assigned) {
                            return (
                              <DoneMark
                                key={`${row._id + String(index)}`}
                                done={day.done}
                                height={16}
                              />
                            );
                          } else {
                            return (
                              <div
                                key={`${row._id + String(index)}`}
                                style={{ width: "16px" }}
                              ></div>
                            );
                          }
                        })}
                        <div className="percentage-column">
                          <b>{tableData.rowAdherenceValues[i]}</b>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {Object.keys(tableData).length === 0 ||
            (tableData.rows.length === 0 && <div>{t("accountabilityTracker.noData")}</div>)}
        </div>
      </section>
    </main>
  );
};

export default AccountabilityTracker;
